// material-ui
import { styled, Theme, CSSObject } from '@mui/material/styles';
import Drawer from '@mui/material/Drawer';

// project imports
import { DRAWER_WIDTH, ThemeMode } from 'config';

// sombra bem suave para a sidebar (mais opaca no dark p/ continuar visível)
const SIDEBAR_SOFT_SHADOW = (theme: Theme) =>
  theme.palette.mode === ThemeMode.DARK ? '0 2px 12px rgba(0, 0, 0, 0.28)' : '0 2px 10px rgba(0, 0, 0, 0.05)';

const openedMixin = (theme: Theme) =>
  ({
    width: DRAWER_WIDTH,
    borderRight: 'none',
    margin: theme.spacing(1.5, 0, 1.5, 1.5),
    borderRadius: typeof theme.shape.borderRadius === 'number' ? theme.shape.borderRadius * 2 : theme.spacing(2),
    // No Electron desce abaixo da barra de título (a altura já desconta tb-offset).
    top: 'var(--tb-offset, 0px)',
    height: `calc(100vh - ${theme.spacing(3)} - var(--tb-offset, 0px))`,

    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    }),

    overflowX: 'hidden',
    boxShadow: SIDEBAR_SOFT_SHADOW(theme),
    '& .MuiDrawer-paper': {
      borderRadius: typeof theme.shape.borderRadius === 'number' ? theme.shape.borderRadius * 2 : theme.spacing(2),
      border: `1px solid ${theme.palette.divider}`,
      boxShadow: SIDEBAR_SOFT_SHADOW(theme)
    }
  }) as CSSObject;

const closedMixin = (theme: Theme) =>
  ({
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),

    overflowX: 'hidden',
    width: theme.spacing(7.5),
    borderRight: 'none',
    margin: theme.spacing(1.5, 0, 1.5, 1.5),
    borderRadius: typeof theme.shape.borderRadius === 'number' ? theme.shape.borderRadius * 2 : theme.spacing(2),
    // No Electron desce abaixo da barra de título (a altura já desconta tb-offset).
    top: 'var(--tb-offset, 0px)',
    height: `calc(100vh - ${theme.spacing(3)} - var(--tb-offset, 0px))`,
    boxShadow: SIDEBAR_SOFT_SHADOW(theme),
    '& .MuiDrawer-paper': {
      borderRadius: typeof theme.shape.borderRadius === 'number' ? theme.shape.borderRadius * 2 : theme.spacing(2),
      border: `1px solid ${theme.palette.divider}`,
      boxShadow: SIDEBAR_SOFT_SHADOW(theme)
    }
  }) as CSSObject;

// ==============================|| DRAWER - MINI STYLED ||============================== //

const MiniDrawerStyled = styled(Drawer, { shouldForwardProp: (prop) => prop !== 'open' })(({ theme }) => ({
  width: DRAWER_WIDTH,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  variants: [
    {
      props: ({ open }) => open,
      style: { ...openedMixin(theme), '& .MuiDrawer-paper': openedMixin(theme) }
    },
    {
      props: ({ open }) => !open,
      style: { ...closedMixin(theme), '& .MuiDrawer-paper': closedMixin(theme) }
    }
  ]
}));

export default MiniDrawerStyled;
